<span class="clearable"
      *ngIf="control.value !== '' && !control.disabled"
      (click)="clear()">
  <i class="fa fa-times-circle"></i>
</span>
